import { render } from "./AftermatchSurvey.vue?vue&type=template&id=8228130c&scoped=true"
import script from "./AftermatchSurvey.vue?vue&type=script&lang=js"
export * from "./AftermatchSurvey.vue?vue&type=script&lang=js"

import "./AftermatchSurvey.vue?vue&type=style&index=0&id=8228130c&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8228130c"]])

export default __exports__